import {
  CORE_GET_FAVORITESEAT_REQUEST,
  CORE_GET_FAVORITESEAT_SUCCESS,
  CORE_GET_FAVORITESEAT_FAILURE,
} from '../../types'
const requestState = 'request'
  , initialState = []
// , initialStateObj = {}
export default {
  seatFavorite: (state = requestState, action) => {
    switch (action.type) {
      case CORE_GET_FAVORITESEAT_REQUEST:
        return requestState
      case CORE_GET_FAVORITESEAT_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_GET_FAVORITESEAT_FAILURE:
        return initialState
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/hotdesk/reducer.js